import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { useTheme, alpha } from '@mui/material/styles';
import { usePipelineConfig } from '../../providers/PipelineConfigProvider';

/**
 * Inaktivitäts-Warnung: dezenter Streifen, wenn ein Datensatz zu lange keine
 * echte Aktivität hatte. Rendert nichts unterhalb der Hinweis-Schwelle.
 * Die Standard-Schwellen kommen aus der Pipeline-Konfiguration (B3);
 * hintDays/warnDays als Props übersteuern sie (z. B. je Phase).
 *   lastActivityAt: ISO-Zeitpunkt der letzten echten Aktivität (oder null)
 */
export default function StaleBanner({ lastActivityAt, hintDays, warnDays }) {
  const theme = useTheme();
  const config = usePipelineConfig();
  if (!lastActivityAt) return null;
  const hint = hintDays ?? config.staleHintDays;
  const warnAt = warnDays ?? config.staleWarnDays;
  const days = Math.floor((Date.now() - new Date(lastActivityAt).getTime()) / 86400000);
  if (isNaN(days) || days < hint) return null;

  const warn = days >= warnAt;
  const c = warn ? theme.palette.error.main : theme.palette.warning.main;

  return (
    <Box sx={{
      display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap',
      px: 2, py: 1, mb: 3, borderRadius: '12px',
      border: '1px dashed', borderColor: alpha(c, 0.5), bgcolor: alpha(c, 0.07),
    }}>
      <AccessTimeIcon sx={{ fontSize: 18, color: c }} />
      <Typography variant="body2" sx={{ color: c, fontWeight: 700 }}>
        Seit {days} Tagen keine Aktivität
      </Typography>
      <Typography variant="caption" color="text.secondary">
        {warn ? 'Dieser Vorgang bleibt liegen — jetzt dranbleiben, bevor er kalt wird.'
              : 'Zeit, wieder Kontakt aufzunehmen.'}
      </Typography>
    </Box>
  );
}
